<template>
<div class="md-layout">
    <div class="md-layout-item md-size-35 md-small-size-hide">
       <main-table :data="data" :lease="true" />
    </div>
    <div class="md-layout-item md-size-65 md-small-size-100">
        <pie v-if="ready" :pieData="pieData" :legendData="legendData"/>
    </div>
</div>
</template>

<script>

import MainTable from '@/components/MainTable';
import Pie from '@/components/Crops/Pie'


export default {
  name: 'net-margin',
  components: {Pie, MainTable},
  props: ['data', 'headers'],

  data() {
    return {
      ready: false,
      legendData: [],
      pieData: []
    }
  },

  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {

      this.legendData = ['Gastos comerciales','Cosecha','Insumos','Labores','Gerenciamiento','Margen Bruto', 'Arrendamiento'];
      this.pieData = [
        {value:this.data['gastos_comerciales'], name:'Gastos comerciales'},
        {value:this.data['cosecha'], name:'Cosecha'},
        {value:this.data['insumos'], name:'Insumos'},
        {value:this.data['labores'], name:'Labores'},
        {value:this.data['gerenciamiento'], name:'Gerenciamiento'},
        {value:this.data['margen_neto'], name:'Margen Neto'},
        {value:this.data['arrendamiento'], name:'Arrendamiento'}
      ]
      this.ready = true
    },
    formatHeader (index) {
      let partial = this.headers[index].replace(/_/g,' ');
      return partial.charAt(0).toUpperCase() + partial.slice(1);
    },
  }
}
</script>
<style>
.table-default{
    font-weight: bold;
    background-color: #eee;
}
.gross-margin-table .md-table-cell{
    padding: 5px;
    font-size:12px;
    height: 33px;
}
</style>
